import React, { useMemo, useState } from 'react';
import './CardGroupLeftPanel.css';
import MagicButton from 'components/MagicButton/MagicButton';
import { Points } from 'components/Points/Points';
import { AssetUrls } from 'config/assets';
import { getAvatarPlaceholder } from 'utils/avatarUtils';

interface CardGroupLeftPanelProps {
  userName: string;
  userAvatar: string;
  userPoints: number;
  imageUrl?: string;
  onRemoveAll?: () => void;
  onSend?: () => void;
  onReset?: () => void;
  isRemoved?: boolean;
}

const CardGroupLeftPanel: React.FC<CardGroupLeftPanelProps> = ({
  userName,
  userAvatar,
  userPoints,
  imageUrl = AssetUrls.sampleCardCrops.chromium,
  onRemoveAll,
  onSend,
  onReset,
  isRemoved = false,
}) => {
  const [imageError, setImageError] = useState(false);
  const avatarPlaceholder = useMemo(() => {
    return getAvatarPlaceholder(userName);
  }, [userName]);

  // Check if we should show the placeholder
  const shouldShowPlaceholder = !userAvatar || 
                                userAvatar === '' || 
                                userAvatar === 'undefined' || 
                                userAvatar === 'null' ||
                                imageError;

  return (
    <div className="card-group-left">
      <div className="artist-image">
        <div className="artist-top-info">
          <div className="user-info">
            {!shouldShowPlaceholder ? (
              <img 
                src={userAvatar} 
                alt={userName} 
                className="user-avatar"
                onError={() => setImageError(true)}
              />
            ) : avatarPlaceholder ? (
              <div 
                className="user-avatar user-avatar-placeholder"
                style={{ backgroundColor: avatarPlaceholder.color }}
              >
                <span className="user-avatar-letter">
                  {avatarPlaceholder.letter}
                </span>
              </div>
            ) : (
              <div 
                className="user-avatar user-avatar-placeholder"
                style={{ backgroundColor: '#8409D3' }}
              >
                <span className="user-avatar-letter">?</span>
              </div>
            )}
            <p className="user-name">
              <strong>{userName}</strong>
            </p>
          </div>
          <Points points={userPoints} type="small" />
        </div>
        <div className="artist-bottom-info">
          {/* Show Remove All / Reset button when we have the handler */}
          {onRemoveAll && (
            <MagicButton
              label={isRemoved ? "Reset" : "Remove All"}
              icon={
                isRemoved ? (
                  <img
                    src="https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/ViewCard/reset.svg"
                    alt="Reset"
                    style={{ width: 16, height: 16 }}
                  />
                ) : (
                  <img
                    src="https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/ViewCard/want-no.svg"
                    alt="Remove"
                    style={{ width: 16, height: 16 }}
                  />
                )
              }
              color="dark-grey"
              fullWidth={true}
              onPress={isRemoved ? (onReset || (() => {})) : onRemoveAll}
            />
          )}
          <MagicButton
            label="Send"
            icon={
              <img
                src={AssetUrls.icons.misc.sendPackage}
                alt="Send Icon"
                style={{ width: 20, height: 20 }}
              />
            }
            color="purple"
            fullWidth={true}
            onPress={onSend || onRemoveAll || (() => {})}
          />
        </div>
      </div>
    </div>
  );
};

export default CardGroupLeftPanel;
